import Document from "./Document";

export default Document;



// WEBPACK FOOTER //
// ./src/components/Document/index.js